import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, className = '', ...props }) => {
  let IconComponent = icon;
  
  if (!IconComponent && name) {
    // Ensure name follows FiName convention
    const iconName = name.startsWith('Fi') ? name : `Fi${name}`;
    IconComponent = FiIcons[iconName];
  }

  if (!IconComponent) {
    return <FiAlertTriangle className={`text-amber-500 ${className}`} {...props} />;
  }

  return <IconComponent className={className} {...props} />;
};

export default SafeIcon;